var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable class-methods-use-this */
import { boundMethod } from 'autobind-decorator';
import { getAllImplementationsOf } from '@tpluscode/all-implementations-of';
export function ResourceScope(Base) {
    class Mixin extends Base {
        constructor() {
            super(...arguments);
            this._stateMapper = null;
        }
        get stateMapper() {
            if (!this._stateMapper) {
                this._stateMapper = this.createStateMapper();
            }
            return this._stateMapper;
        }
        connectedCallback() {
            if (super.connectedCallback) {
                super.connectedCallback();
            }
            this.addEventListener('navigator-attach', (e) => {
                e.detail.resourceScope = this;
            }, true);
            document.addEventListener('ld-navigated', this.__onNavigated);
            window.addEventListener('popstate', this.__onNavigated);
            window.addEventListener('pushstate', this.__onNavigated);
            window.addEventListener('hashchange', this.__onNavigated);
            this.notifyResourceUrlChanged();
        }
        disconnectedCallback() {
            document.removeEventListener('ld-navigated', this.__onNavigated);
            window.removeEventListener('popstate', this.__onNavigated);
            window.removeEventListener('pushstate', this.__onNavigated);
            window.removeEventListener('hashchange', this.__onNavigated);
            if (super.disconnectedCallback) {
                super.disconnectedCallback();
            }
        }
        get mappedResourceUrl() {
            if (this.stateMapper instanceof Promise) {
                return this.stateMapper.then(sm => sm.getResourceUrl(document.location.href));
            }
            return this.stateMapper.getResourceUrl(document.location.href);
        }
        async notifyResourceUrlChanged(value) {
            const prevUrl = this.resourceUrl;
            this.resourceUrl = value || (await this.mappedResourceUrl);
            if (this.resourceUrl !== prevUrl) {
                getAllImplementationsOf(this, 'onResourceUrlChanged').forEach(fn => fn.call(this, this.resourceUrl));
            }
        }
        __onNavigated(e) {
            if (e.detail && e.detail.resourceUrl) {
                this.notifyResourceUrlChanged(e.detail.resourceUrl).then(this.__notifyUrlChange);
            }
            else {
                this.notifyResourceUrlChanged().then(this.__notifyUrlChange);
            }
        }
        __notifyUrlChange() {
            this.dispatchEvent(new Event('url-changed'));
        }
    }
    __decorate([
        boundMethod
    ], Mixin.prototype, "notifyResourceUrlChanged", null);
    __decorate([
        boundMethod
    ], Mixin.prototype, "__onNavigated", null);
    __decorate([
        boundMethod
    ], Mixin.prototype, "__notifyUrlChange", null);
    return Mixin;
}
